import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class StudentService {
	constructor(private httpclientService: HttpclientService) {}
	loadStudentList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/StudentGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
